// Light formatting helpers — no big date library, this is enough for now.

// The server's toIST() sends "YYYY-MM-DD HH:MM:SS" already shifted to IST
// (UTC+5:30) with no zone marker. Parsing that as UTC made every "last seen"
// read 5½ hours too recent, so zone-less server times are read as IST.
export function parseServerTime(value: string): number {
  if (value.includes('T')) return new Date(value).getTime();
  return new Date(value.replace(' ', 'T') + '+05:30').getTime();
}

export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return 'never';
  const t = parseServerTime(iso);
  if (Number.isNaN(t)) return iso;
  const diff = Date.now() - t;
  if (diff < 0) return 'just now';
  const sec = Math.floor(diff / 1000);
  if (sec < 60) return `${sec}s ago`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 30) return `${day}d ago`;
  const mo = Math.floor(day / 30);
  if (mo < 12) return `${mo}mo ago`;
  return `${Math.floor(mo / 12)}y ago`;
}

export function clsx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
